import React from 'react';
import {
  Button,
  Transition,
  Grid,
  Form,
  Header
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { setPageRequestFibrestream } from '../../../store/actions/app';

class ServiceIsAvailable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation,
    };
    this.transitionBack = this.transitionBack.bind(this);
    this.closeAvailabilityModal = this.closeAvailabilityModal.bind(this);

  }

  closeAvailabilityModal(e) {

  }

  continue() {
    var offset = document.body.scrollTop;
    document.body.style.top = (offset * -1) + 'px';
    document.body.classList.add('modal--opened');
    // this.setState({
    //   animation: "fade right",
    //   visible: false
    // });

    this.props.setPageRequestFibrestream(true);
    setTimeout(() => {
      this.props.history.push('/check');
    }, 400);
  }

  transitionBack() {
    const { changeStep } = this.props;

    this.setState({
      animation: "fade left",
      visible: !this.state.visible
    });
    setTimeout(() => {
      changeStep(9, "fade right")
    }, 400);
  }

  componentDidMount() {
    this.setState({
      visible: true
    });
  }

  componentWillUnmount() {
    this.closeAvailabilityModal();
  }

  render() {
    const { visible, animation } = this.state;
    return <div>
      <div className="back--icon" onClick={this.transitionBack} />
      <Transition visible={visible} duration={500} animation={animation}>
        <div className="building-form">
          <Header className="title__main" as="h1" textAlign="center">
            Service Available
          </Header>
          <Header.Subheader className="text-black">
            Service is available in your building.
          </Header.Subheader>
          <Form className="form check-address">
            <Grid className="mx-0 my-0">
              <Button className='btn--full' type="button" size='medium' onClick={this.continue.bind(this)}>Get Fibre Now</Button>
            </Grid>
          </Form>
        </div>
      </Transition>
    </div>
  };
}
const mapStateToProps = state => {
  return {
    openAvailabilityModal: state.app.openAvailabilityModal,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setPageRequestFibrestream: (flag) => dispatch(setPageRequestFibrestream(flag)),

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ServiceIsAvailable));



// WEBPACK FOOTER //
// ./src/components/check-availability/service-not-available/ServiceIsAvailable.js